import { TrendingDown, TrendingUp } from "lucide-react";

interface StatCardProps {
  title: string;
  value: string | number;
  change: number;
  sparklineData?: number[];
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  change,
  sparklineData = [],
}) => {
  const isPositive = change >= 0;

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <p className="text-gray-500 text-sm font-medium mb-2">{title}</p>
          <h3 className="text-3xl font-bold text-gray-900">{value}</h3>
        </div>
        {sparklineData.length > 0 && (
          <div className="ml-4">
            <svg width="64" height="48" className="text-gray-300">
              <polyline
                points={sparklineData
                  .map((val, idx) => {
                    const x = (idx / (sparklineData.length - 1)) * 60;
                    const y = 48 - (val / Math.max(...sparklineData)) * 40;
                    return `${x},${y}`;
                  })
                  .join(" ")}
                fill="none"
                stroke={isPositive ? "#22c55e" : "#ef4444"}
                strokeWidth="2"
              />
            </svg>
          </div>
        )}
      </div>
      <div className="flex items-center justify-between gap-2 text-sm">
        <span className="text-gray-500 mr-2">Since last month</span>
        <span
          className={`flex items-center font-semibold ${
            isPositive ? "text-green-600" : "text-red-600"
          }`}
        >
          {isPositive ? "+" : ""}
          {change.toFixed(2)}%
          {isPositive ? (
            <TrendingUp className="ml-1 w-4 h-4" />
          ) : (
            <TrendingDown className="ml-1 w-4 h-4" />
          )}
        </span>
      </div>
    </div>
  );
};

export default StatCard;
